import ApplyContract from '../mutations/ApplyContract.gql'

export default function (variables) {
  return {
    mutation: ApplyContract,
    variables: variables,
  }
}
